import Button from "components/molecules/Button";
import Field from "components/molecules/Field";
import {useForm} from "components/molecules/Form";
import Form from "components/molecules/Form/Form";
import React, {useEffect, useState} from "react";
import styled from "styled-components";

const StyledComboDetails = styled.div`
    width: 100%;
    .title {
        color: var(--text-color);
        font-size: 20px;
        line-height: 24px;
        font-weight: 400;
        margin-bottom: 30px;
    }
    .input-field-wrap {
        .label {
            font-size: 18px;
            line-height: 22px;
            font-weight: 400;
        }
        textarea {
            min-height: 110px;
        }
        .labelButton {
            height: 170px;
        }
    }
    .field-wrap {
        margin-bottom: 30px;
        .label {
            display: block;
            color: var(--text-color);
            font-size: 18px;
            line-height: 22px;
            font-weight: 400;
            margin-bottom: 15px;
        }
        .categories {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 15px;
            .category {
                padding: 7px 10px;
                border: 1px solid rgba(205, 205, 205, 1);
                border-radius: 30px;
                color: var(--text-color);
                font-size: 12px;
                line-height: 16px;
                font-weight: 400;
                cursor: pointer;
                &.active {
                    color: var(--white);
                    background-color: var(--primary);
                    border: none;
                }
            }
        }
    }
    .btn-holder {
        display: flex;
        justify-content: center;
        .btn {
            min-width: auto;
        }
    }
`;

const comboLabels = ["Popular", "New", "Limited Time", "Best Value", "Chef Special"];

const ComboDetails = ({formData, setActiveTab, setFormData}) => {
    const [form] = useForm();
    const [comboLabel, setComboLabel] = useState([]);

    useEffect(() => {
        if (formData?.form1) {
            form.setFieldsValue({
                comboName: formData?.form1?.comboName,
                description: formData?.form1?.description,
                photo: formData?.form1?.itemImg,
            });
            setComboLabel(formData?.form1?.comboLabels ?? []);
        }
    }, [form, formData]);

    function handleComboLabel(item) {
        if (comboLabel.includes(item)) {
            setComboLabel(prev => prev.filter(elem => elem !== item));
        } else {
            setComboLabel(prev => [...prev, item]);
        }
    }

    function handleSubmit(e) {
        const stepOne = {
            comboName: e?.comboName,
            description: e?.description,
            comboLabels: comboLabel,
            itemImg: e?.photo,
        };
        console.log("stepOne:", stepOne);
        setFormData(prev => ({
            ...prev,
            form1: {...stepOne},
        }));
        setActiveTab(1);
    }
    return (
        <StyledComboDetails>
            <h2 className="title">Basic Information</h2>
            <Form form={form} onSubmit={handleSubmit}>
                <Form.Item
                    label="Combo Name *"
                    $bgWhite
                    type="text"
                    name="comboName"
                    placeholder="e.g., Lunch Special, Family Feast"
                    rules={[
                        {
                            required: true,
                            message: "Combo Name is required",
                        },
                    ]}>
                    <Field />
                </Form.Item>

                <Form.Item
                    label="Description *"
                    $bgWhite
                    type="textarea"
                    name="description"
                    placeholder="Describe what makes this combo special..."
                    rules={[
                        {
                            required: true,
                            message: "Description is required",
                        },
                    ]}>
                    <Field />
                </Form.Item>

                <div className="field-wrap">
                    <strong className="label">Combo Label (Optional)</strong>
                    <ul className="categories">
                        {comboLabels.map((item, index) => (
                            <li
                                className={comboLabel.includes(item) ? "category active" : "category"}
                                key={index}
                                onClick={() => handleComboLabel(item)}>
                                {item}
                            </li>
                        ))}
                    </ul>
                </div>

                <Form.Item
                    $bgWhite
                    type="img"
                    name="photo"
                    uploadTitle="Upload Disg Photo"
                    disc="You can upload upto 2MB, Image (JPG, PNG)">
                    <Field />
                </Form.Item>
                <div className="btn-holder">
                    <Button width="432px" className="btn">
                        Next
                    </Button>
                </div>
            </Form>
        </StyledComboDetails>
    );
};

export default ComboDetails;
